import {toast, ToastOptions} from 'react-toastify';
import React from 'react';
import {ToastMessage, ToastType} from './toasts.types';
import CLToast from '../../components/CLToast/CLToast';

const options: ToastOptions = {
  className: 'cl_common_toast',
  bodyClassName: 'cl_common_toast_body',
  hideProgressBar: true,
  closeOnClick: false,
};

const UNEXPECTED_ERROR_DEFAULT_MESSAGE = 'Something went wrong. Please try again.';

function notify(type: ToastType, toastMessage: ToastMessage, toastOptions?: ToastOptions) {
  const setOptions = Object.assign(options, toastOptions);

  const toastElement = <CLToast title={toastMessage.title} message={toastMessage.message} />;

  switch (type) {
    case ToastType.Info:
      return toast.info(toastElement, setOptions);
    case ToastType.Error:
      return toast.error(toastElement, setOptions);
    case ToastType.Success:
      return toast.success(toastElement, setOptions);
    case ToastType.Warning:
      return toast.warning(toastElement, setOptions);
  }
}

const emit = {
  error: (message: ToastMessage, toastOptions?: ToastOptions) =>
    notify(ToastType.Error, message, toastOptions),
  success: (message: ToastMessage, toastOptions?: ToastOptions) =>
    notify(ToastType.Success, message, toastOptions),
  info: (message: ToastMessage, toastOptions?: ToastOptions) =>
    notify(ToastType.Info, message, toastOptions),
  warn: (message: ToastMessage, toastOptions?: ToastOptions) =>
    notify(ToastType.Warning, message, toastOptions),
};

function emitGeneralErrorToast() {
  emit.error({title: 'An Error Occurred', message: UNEXPECTED_ERROR_DEFAULT_MESSAGE});
}

export {emit, emitGeneralErrorToast};
